module.exports = __webpack_public_path__ + "static/img/logo.43c81075.png";